<template>
  <!-- 首页 -->
  <div class="main">
    <a-row :gutter="24">
      <a-col :md="6" :sm="24">
        <div class="nav">
          <img src="/icon-ongoing@__2x.png" alt="" />
          <div>
            <div class="title">待施工项目</div>
            <div class="amount">{{ eringList.projectToBeConstructed }}</div>
          </div>
        </div>
      </a-col>
      <a-col :md="6" :sm="24">
        <div class="nav">
          <img src="/icon-new-project@2x.png" alt="" />
          <div>
            <div class="title">进行中项目</div>
            <div class="amount">{{ eringList.ongoingProject }}</div>
          </div>
        </div>
      </a-col>
      <a-col :md="6" :sm="24">
        <div class="nav">
          <img src="/icon-completed@2x.png" alt="" />
          <div>
            <div class="title">已完成项目</div>
            <div class="amount">{{ eringList.completedProjects }}</div>
          </div>
        </div>
      </a-col>
      <a-col :md="6" :sm="24">
        <div class="nav">
          <img src="/icon-shut-down@2x.png" alt="" />
          <div>
            <div class="title">已验收项目</div>
            <div class="amount">{{ eringList.approvedProjects }}</div>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :md="12" :sm="24">
        <apply-for />
        <gross-assets />
      </a-col>
      <a-col :md="12" :sm="24">
        <survey />
        <pipeline-kilometers />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import ApplyFor from './workbench-module/apply-for.vue'
import survey from './workbench-module/survey.vue'
import GrossAssets from './workbench-module/gross-assets.vue'
import PipelineKilometers from './workbench-module/pipeline-kilometers.vue'
export default {
  components: {
    ApplyFor,
    survey,
    GrossAssets,
    PipelineKilometers,
  },
  data() {
    return {
      eringList: [],
    }
  },
  created() {
    this.Homebottome()
    this.setSystemName()
  },
  methods: {
    setSystemName() {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}工程管理系统`)
    },
    Homebottome() {
      this.$http.get('/pipe-network/engineering_project_applys/index-top').then((res) => {
        this.eringList = res.data
        console.log(res.data, 'hjjdjj')
      })
    },
  },
}
</script>

<style lang='less' scoped>
.main {
  width: 100%;
  height: 824px;
  // border: 1px solid red;
}
.nav {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 4px;
}
img {
  width: 60px;
  height: 60px;
  margin: 0 18px 0 24px;
}
.title {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  color: #898e98;
  letter-spacing: 0.71px;
  font-weight: 400;
}
.amount {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 24px;
  color: #333333;
  letter-spacing: 0.95px;
  font-weight: 600;
}
</style>